/**
 * Main Application JavaScript
 * This file imports all modules and initializes them
 */

import { initRacesSlider } from './blocks/races-slider.js';
import { initTestimonialsSlider } from './blocks/testimonials-slider.js';
import { initContactForm } from './blocks/contact-form.js';
import { initNavigation } from './blocks/navigation.js';
import { initScroll } from './blocks/scroll.js';
import { initButtons } from './blocks/buttons.js';
import { initGlobal } from './blocks/global.js';
import { initValeursSlider } from './blocks/valeurs-slider.js';
import { initValeursIcons } from './blocks/valeurs-icons.js';
import { initMenu } from './blocks/menu.js';
import { initHeroScroll } from './blocks/hero-scroll.js';
import { initRaceGallery, initProductGallery } from './blocks/gallery-slider.js';
import {initSafariVideoFix} from './blocks/safari-video-fix.js';

document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize global utilities
    initGlobal();
    
    // Initialize navigation
    initNavigation();
    
    // Initialize mobile menu
    initMenu();

    // Initialize Safari Video Fix
    initSafariVideoFix();
    
    // Initialize buttons
    initButtons();
    
    // Initialize races slider
    initRacesSlider();
    
    // Initialize testimonials slider
    initTestimonialsSlider();

    // Initialize contact form
    initContactForm();
    
    // Initialize scroll sync
    initScroll();
    
    // Initialize valeurs slider
    initValeursSlider();
    
    // Initialize valeurs icons scroll
    initValeursIcons();
    
    // Initialize hero background scroll effect
    initHeroScroll();
    
    // Initialize gallery functionality for races and products pages
    initRaceGallery();
    initProductGallery();
    
});